import { Action } from 'redux';

export const GET_RPE_EVENTS_ACTION = 'rpe-events/GET_RPE_EVENTS_ACTION';
export const PERSIST_RPE_EVENTS_ACTION = 'rpe-events/PERSIST_RPE_EVENTS_ACTION';

export interface GetRPEEventsAction extends Action<typeof GET_RPE_EVENTS_ACTION> {
  readonly payload: {
    readonly params?: RPEEventFilterQueryParams;
  };
}
export const getRPEEvents = (params?: RPEEventFilterQueryParams): GetRPEEventsAction => ({
  payload: {
    params,
  },
  type: GET_RPE_EVENTS_ACTION,
});

export interface PersistRPEEventsAction extends Action<typeof PERSIST_RPE_EVENTS_ACTION> {
  readonly payload: {
    readonly events: ReadonlyArray<RPEEventModel>;
  };
}
export const persistRPEEvents = (events: ReadonlyArray<RPEEventModel>): PersistRPEEventsAction => ({
  payload: {
    events,
  },
  type: PERSIST_RPE_EVENTS_ACTION,
});

export type RPEEventAction = GetRPEEventsAction | PersistRPEEventsAction;
